



















































import { Component, Vue } from 'vue-property-decorator'
import { listTenants } from '../services/tenants'
import { ITenant } from '../types/types'

const USERS_TENANT = 'users:tenant'
const setCurrentTenantStorage = (tenant: ITenant) =>
  (sessionStorage[USERS_TENANT] = JSON.stringify(tenant))

@Component
export default class Tenants extends Vue {
  tenants: any = []
  loadingTenants = false

  type = {
    free: 'is-info',
    trial: 'is-warning',
    basic: 'is-primary',
    advanced: 'is-link',
    enterprise: 'is-success',
  }

  async getTenants() {
    try {
      this.loadingTenants = true
      this.tenants = await listTenants()
    } catch (error) {
      this.$buefy.toast.open({
        message: 'Falha ao listar tenants',
        type: 'is-danger',
      })
    } finally {
      this.loadingTenants = false
    }
  }

  selectedTenant(tenant: string) {
    setCurrentTenantStorage({ tenantName: tenant, selected: true })
    this.$router.push({ name: 'customer' })
  }

  mounted() {
    this.getTenants()
  }
}
